import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InfoBarMapViewService {


  private dataRetrive = new Subject<{ resource_values: any, burg_values?: any }>()
  dataRetriver$ = this.dataRetrive.asObservable();
  constructor() { }

  setNewInfo(value: { resource_values: any, burg_values?: any }) {
    this.dataRetrive.next({ resource_values: value.resource_values, burg_values: value.burg_values });
  }
}
